import React from "react";
import DataTableActions from "components/common/datatable/DataTableActions";
import i18next from "i18next";
import {
  cellWithTooltip,
  dateValueFormatter,
} from "components/common/datatable/EADataGrid";
import MainHeaderCell from "components/common/datatable/MainHeaderCell";
import { PrivilegeEnum } from "services/common/RolesUtils";

const editableValue = [
  "list_unique",
  "list_multiple"
]

const attributesTableActions = (
  attributes,
  openEditDialog,
  openDeleteDialog,
  openReadDialog,
  hasAnyOfPrivileges,
  bondType,
  type
) => {

  const isEditDisabled = () => {
    if(!bondType) {
        return (
          !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_ALL_PARTNER_ATTRIBUTE) &&
          !(hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_PARTNER_ATTRIBUTE_OPTIONS) && editableValue.includes(type[0]))
        );
    } else {
      switch (bondType) {
        case "dossier":
          return (
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_ALL_DOSSIER_ATTRIBUTE) &&
            !(hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_DOSSIER_ATTRIBUTE_OPTIONS) && editableValue.includes(type[0]))
          );
        case "thirdparty":
          return (
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_ALL_THIRD_PARTY_ATTRIBUTE) &&
            !(hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_THIRD_PARTY_ATTRIBUTE_OPTIONS) && editableValue.includes(type[0]))
          );
        case "context":
          return (
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_ALL_CONTEXT_ATTRIBUTE) &&
            !(hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_CONTEXT_ATTRIBUTE_VALUE) && editableValue.includes(type[0]))
          );
        default:
          return true;
      }
    }
  };

  const isDeleteDisabled = () => {
    if(!bondType) {
      return !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_DELETE_PARTNER_ATTRIBUTE);
    } else {
      switch (bondType) {
        case "dossier":
          return !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_DELETE_DOSSIER_ATTRIBUTE);
        case "thirdparty":
          return !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_DELETE_THIRD_PARTY_ATTRIBUTE);
        case "context":
          return !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_DELETE_CONTEXT_ATTRIBUTE);
        default:
          return true;
      }
    }
  };


  return [
    {
      label: i18next.t("read"),
      icon: "open-eye",
      action: () => openReadDialog(attributes[0]),
      isDisabled:
        bondType === "dossier"
          ? !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE)
          : !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ATTRIBUTE)
    },
    {
      label: i18next.t("modify"),
      icon: "edit_grey",
      action: () => openEditDialog(attributes[0]),
      isDisabled: isEditDisabled()
    },
    {
      label: i18next.t("delete"),
      icon: "delete_grey",
      action: () => openDeleteDialog(attributes),
      isDisabled: isDeleteDisabled()
    },
  ];
};

export const attributesListColumns = (
  openEditDialog,
  openDeleteDialog,
  openReadDialog,
  hasAnyOfPrivileges,
  bondType,
  history,
  accountId
) => {
  return [
    {
      field: "label",
      headerName: i18next.t("attributes.label"),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell name={i18next.t("attributes.label")} />
      ),
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "typeLabel",
      headerName: i18next.t("attributes.type"),
      flex: 0.1,
      renderCell: (params) =>  {
        return cellWithTooltip(params.value)
      },
    },
    ...(!bondType
      ? [
          {
            field: "category",
            headerName: i18next.t("attributes.category.label"),
            flex: 0.1,
            renderCell: (params) =>  {
              return cellWithTooltip(i18next.t(`attributes.category.${params.value}`))
            },
          }] : []
    ),
    ...(bondType === 'context'
      ? [
          {
            field: 'bondType',
            headerName: `${i18next.t(
              'demandes.contextModel.contextModelListColumns.attributs'
            )}`,
            flex: 0.1,
            renderCell: (params) => {
              if (params.rowNode?.groupingKey) {
                return <></>//i18next.t(`attributes.column_${params.rowNode?.groupingKey}`);
              }
              return cellWithTooltip(i18next.t(`attributes.column_${params.value}`))
            }
          },
          {
            field: 'modelName',
            headerName: `${i18next.t(
              'demandes.contextModel.contextModelListColumns.associatedModel'
            )}`,
            flex: 0.1,
            renderCell: (params) => {
              return <div
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
                onClick={()=> {
                  history.push(`/${accountId}/admin?tab=demandes&config=2&model=${params.row.ctxModelId}`)
                }}
              >
                {params.value}
              </div>
            }
          },
        ]
      : []),
    {
      field: "creationDate",
      headerName: i18next.t("creationDate"),
      flex: 0.1,
      type: "date",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => dateValueFormatter(params),
    },
    {
      field: "updateDate",
      headerName: i18next.t("updatedDate"),
      flex: 0.1,
      type: "date",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => dateValueFormatter(params),
    },
    {
      field: "isRequired",
      headerName: i18next.t("required"),
      flex: 0.08,
      type: "boolean",
      renderCell: (params) => {
          const bool = !!params.value;
          return cellWithTooltip(bool? "Oui" : "Non");
      },
    },
    {
      field: "action",
      headerName: i18next.t("actions"),
      flex: 0.05,
      sortable: false,
      filterable: false,
      disableExport: true,
      hideSortIcons: true,
      disableReorder: true,
      disableColumnMenu: true,
      disableMultipleSelection: true,
      disableSelectionOnClick: true,
      isRowSelectable: false,
      hideFooterSelectedRowCount: true,
      align: "center",
      renderCell: (params) => {
        return (
          <div style={{ textAlign: "center" }}>
            <DataTableActions
              actions={attributesTableActions(
                [params.row.id],
                openEditDialog,
                openDeleteDialog,
                openReadDialog,
                hasAnyOfPrivileges,
                bondType,
                [params.row.type],
              )}
            />
          </div>
        );
      },
    },
  ];
};
